module.exports = __webpack_public_path__ + "static/media/211ME109.15650348.jpg";